<!-- 列表详情组件 -->
<template>
  <div class="detail">
    <div class="detail-header" v-html="detailData.description"></div>
    <div style="position: relative; padding: 20px" v-if="detailData.img">
      <van-image
        :width="'100%'"
        height="100%"
        fit="cover"
        :src="detailData.img"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "detail1",
  props: {
    datas: Object,
  },
  data() {
    return {
      detailData: {},
    };
  },

  created() {
    // 获取文章详情
    console.log(
      "详情1111111111111",
      this.datas,
      this.detailData,
      this.$route.query.pageId,
    );
    this.getArticleDetail();
  },
  methods: {
    // 获取文章详情
    async getArticleDetail() {
      const res = await this.$api.admin.article.getArticleDetailAPI({
        id: this.$route.query.pageId,
      });
      if (res.code == 200) {
        console.log(
          "获取文章详情1111111111111结果",
          this.$route.query,
          res.data,
        );
        this.detailData = res.data;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.detail {
  height: 100%;
  .detail-header {
    padding: 20px;
  }
}
</style>
